/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useApiRequest, IResponsePayload } from '../../../hooks/useApiRequest';
import { URLS } from '../../../constants/urls.constants';
import { stopLoading } from '../../../store/modules/loading';
import { setAlert } from '../../../store/modules/snackbar';
import { RootState } from '../../../store';
import { IFunctionalResponse } from '../../../interfaces/project.interface';

const useGetUF_UE = () => {
	const dispatch = useDispatch<any>();
	const { _id } = useSelector((root: RootState) => root.projectBase);
	const { execute, status, value } = useApiRequest<
		any,
		IResponsePayload<IFunctionalResponse>
	>({
		path: URLS.PROJECT.FUNCTIONAL,
		method: 'GET',
	});

	useEffect(() => {
		execute(null, `?project=${_id}&totalRecords=1000`);
	}, []);

	useEffect(() => {
		if (status === 'success') {
			dispatch(stopLoading());
		} else if (status === 'error') {
			dispatch(stopLoading());
			dispatch(
				setAlert({
					show: true,
					message: 'Ocurrió un error al actualizar el proyecto',
					severity: 'error',
				})
			);
		}
	}, [status]);

	return { execute, value };
};

export default useGetUF_UE;
